import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import desktopOrnament1 from './img/ornament1.svg'
import desktopOrnament2 from './img/ornament2.svg'
import photoImg from './img/intro287desktop-couple-image-3B7A0412-CFDF-401B-B4E5-161C22469F2C.jpg'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'já se casaram!'
      : 'vão se casar!'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro287">
      <div className="intro287mobile-all-breakpoints screen">
        <div className="main-background-RPlD7A"></div>
        <div className="container-center-horizontal">
          <div className="button-RPlD7A">
            <div
              className="site-de-casamento-e-BFWbcD"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-BFWbcD" onClick={onSkipIntro}>
              <div className="button-SDk3DX"></div>
              <div className="pular-introduo-SDk3DX">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <img className="couple-image-RPlD7A" src={background || photoImg} />
        </div>
        <div className="container-center-horizontal">
          <div className="overlay-couple-RPlD7A"></div>
        </div>
        <div className="container-center-horizontal">
          <div className="ornaments-RPlD7A">
            <img
              className="ornament-2-Uxhcsi bp2-intro287-animate-enter"
              src={desktopOrnament2}
            />
            <img
              className="ornament-1-Uxhcsi bp2-intro287-animate-enter1"
              src={desktopOrnament1}
            />
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="couple-single-namebr-RPlD7A bp2-intro287-animate-enter2">
            {coupleSingleName.bride} &amp; {coupleSingleName.groom}
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="vo-se-casar-RPlD7A">{text}</div>
        </div>
      </div>
      <div className="intro287desktop screen">
        <div className="main-background-pBHBmJ bp1-intro287-animate-enter"></div>
        <div className="container-center-horizontal">
          <div className="button-pBHBmJ">
            <div
              className="site-de-casamento-e-qtxxeW"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-qtxxeW" onClick={onSkipIntro}>
              <div className="button-lXU7yq"></div>
              <div className="pular-introduo-lXU7yq">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <img className="couple-image-pBHBmJ" src={background || photoImg} />
        </div>
        <div className="container-center-horizontal">
          <div className="overlay-couple-pBHBmJ"></div>
        </div>
        <div className="container-center-horizontal">
          <div className="ornaments-pBHBmJ">
            <img
              className="ornament-2-OxJezk bp1-intro287-animate-enter1"
              src={desktopOrnament2}
            />
            <img
              className="ornament-1-OxJezk bp1-intro287-animate-enter2"
              src={desktopOrnament1}
            />
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="couple-single-namebr-pBHBmJ bp1-intro287-animate-enter3">
            {coupleSingleName.bride} &amp; {coupleSingleName.groom}
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="vo-se-casar-pBHBmJ">{text}</div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
